import React, { useState, useCallback, useEffect, useMemo } from 'react';
import { useForm } from 'react-hook-form';
import { v4 } from 'uuid';
import Typo from 'components/shared/Typo';
import Button from 'components/shared/Button';
import Dialog from 'components/shared/Dialog';
import Form from 'components/shared/Form';
import { defaultProperties } from '../../constants';
import GainSettingsTable from '../GainSettingsTable';
import GainSettingsProps from '../GainSettingsProps';
import { findLatestLastUpdatedValue } from 'common/utils/helpers';
import styles from './GainSettingsDialog.module.css';

function GainSettingsDialog({ properties, open, su1, su2, su3, su4, onSubmit, onClose }) {
  const [titleId] = useState(() => v4());
  const methods = useForm({ mode: 'onChange', defaultValues: defaultProperties });
  const { formState, reset } = methods;
  const { isSubmitting, isDirty, isValid } = formState;
  const handleReset = useCallback(
    (event) => {
      event.preventDefault();
      onClose();
      reset();
    },
    [reset, onClose]
  );

  const latestVersionLastUpdated = useMemo(() => {
    const mockDevice = { properties: { reported: properties } };
    return findLatestLastUpdatedValue(mockDevice, 'az-el-info');
  }, [properties]);

  useEffect(() => {
    if (formState.isSubmitSuccessful) {
      reset();
    }
  }, [formState, reset]);

  const maxWidth = [su1, su2, su3, su4].filter(Boolean).length * 216 + 456 + 8;

  return (
    <Dialog aria-labelledby={titleId} open={open} onClose={onClose}>
      <Dialog.Container
        as={Form}
        methods={methods}
        onSubmit={onSubmit}
        maxWidth={maxWidth}
        className={styles.container}
      >
        <Dialog.Title>
          <Typo id={titleId} as="h3" variant="heading5">
            Advanced Settings
          </Typo>
        </Dialog.Title>
        <Dialog.Content>
          <GainSettingsProps props={properties}>
            <GainSettingsTable su1={su1} su2={su2} su3={su3} su4={su4} />
          </GainSettingsProps>
        </Dialog.Content>
        <Dialog.Actions className={styles.actions}>
          <Button type="reset" variant="text" color="primary" size="medium" onClick={handleReset}>
            Cancel
          </Button>
          <Button
            Title="Reload the page to view the updated value"
            type="submit"
            variant="contained"
            color="primary"
            size="medium"
            disabled={isSubmitting || !isValid || !isDirty}
          >
            Apply
          </Button>
        </Dialog.Actions>
        <div className={styles.lastUpdated}>
          <div className={styles.lastUpdatedTitle}>Last Updated: {latestVersionLastUpdated}</div>
        </div>
        <Dialog.Close />
      </Dialog.Container>
    </Dialog>
  );
}

export default GainSettingsDialog;
